import { Component, OnInit } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ClientService } from 'src/app/core/services/clientService/client.service';
import { Observable } from 'rxjs';
import { switchMap, map, count } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  data$: Observable<any[]>;

  constructor(private http: HttpClient,     private clientService: ClientService    ) {}

  ngOnInit() {
    console.log('footer ngOnInit');
    this.data$ = this.clientService.getStats();
  }

  refresh(){
    console.log('refresh called');
    this.data$ = this.clientService.getStats();
  }

}
